import {
  SHOW_USER_FORM_COMMON, ASSIGN_PRODUCT, GET_ESTIMATES, AUTH_USER,
  UPDATE_ASSIGN_PRODUCTS,
  FILTER_COMPANIES,
  FILTER_CLIENTS,
  FILTER_PRODUCTS,
  LOADER,
  DASHBOARD_DATA,
  REMOVE_ASSIGN_PRODUCT_FROM_COMMON,
  UPDATE_PRODUCT_USERS,
  GET_STATES,
  GET_CITIES,
  ERROR_DIALOG,
  FILTER_SUPPLIERS,
  FILTER_RO,
  FILTER_CLIENTS_DASHBOARD,
  FILTER_PRODUCTS_CLIENTS_DASHBOARD,
  FILTER_CAMPAIGNS_CLIENTS_DASHBOARD,
  FILTER_SITES_CLIENTS_DASHBOARD,
  FILTER_CLIENTS_CAMPAIGNS,
  FILTER_CLIENTS_DASHBOARD_DATA,
  FILTER_ESTIMATES_CLIENTS_DASHBOARD,
  FILTER_SITES_AUDITOR_DASHBOARD,
  UPDATE_AUDITOR_SITES,
} from '../actionTypes';

const initalState = {
  primaryFilters: [],
  showUserForm: false,
  clients: [],
  clientsCampaigns: [],
  clientsDashboard: [],
  clientDashboardData: [],
  productsOfClientDashboard: [],
  campaignsOfClientDashboard: [],
  estimatesOfClientDashboard: [],
  sitesOfClientDashboard: [],
  sitesOfAuditorDashboard: [],
  clientCities: [],
  clientStates: [],
  clientMediaTypes: [],
  companies: [],
  products: [],
  estimates: [],
  isAuthUser: false,
  productFilter: [],
  loading: false,
  states: [],
  suppliers: [],
  ro: [],
  dashboardReports: {
    reported: null,
    rejected: null,
    approved: null,
    delayed: null,
  },
  errorDialog: '',
};

const CommonReducer = (state = initalState, action) => {
  switch (action.type) {
    case AUTH_USER: {
      return {
        ...state,
        isAuthUser: action.payload,
      };
    }
    case SHOW_USER_FORM_COMMON: {
      return {
        ...state,
        showUserForm: action.payload,
      };
    }
    case ASSIGN_PRODUCT: {
      const data = [...action.payload.data];
      const { productId } = action
      const products = [...state.products];
      const ind = products.findIndex((itm) => itm.id === productId);
      const arr = []
      data.map((item) => {
        arr.push(item.dashUser);
        return true;
      });
      if (products[ind].managerProduct && Array.isArray(products[ind].managerProduct)) {
        products[ind].managerProduct = [...products[ind].managerProduct, ...arr]
      } else if (products[ind].managerProduct) {
        const user = products[ind].managerProduct.dashUser
        products[ind].managerProduct = []
        products[ind].managerProduct = [{ ...user }]
        products[ind].managerProduct = [...products[ind].managerProduct, ...arr]
      } else {
        products[ind].managerProduct = []
        products[ind].managerProduct = [...products[ind].managerProduct, ...arr]
      }
      return {
        ...state,
        showUserForm: false,
        products: [...products],
      }
    }
    case GET_ESTIMATES: {
      const estimates = [...action.payload]
      estimates.sort((a, b) => (a.estimateDate < b.estimateDate ? 1 : -1));
      const est = estimates.map((item) => {
        const obj = { ...item }
        obj.text = `${obj.estimateNo} - ${obj.campaignDescription}`
        obj.value = obj.estimateId
        return obj;
      })
      return {
        ...state,
        estimates: [...est],
      }
    }
    case UPDATE_ASSIGN_PRODUCTS: {
      const assignedProducts = [...action.payload.data]
      const oldProducts = [...state.products]
      assignedProducts.map((item) => {
        const ind = oldProducts.findIndex((itm) => itm.id === item.productId)
        oldProducts.splice(ind, 1)
        return true;
      })
      return {
        ...state,
        products: [...oldProducts],
      }
    }
    case FILTER_COMPANIES: {
      const companies = [...action.payload.companies]
      const companyFilter = companies.map((item) => (
        { text: item.CompanyName, value: item.CompanyCode }));
      return {
        ...state,
        companies: [...companyFilter],
        clients: [],
        products: [],
        productFilter: [],
        estimates: [],
      }
    }
    case FILTER_CLIENTS: {
      const clients = [...action.payload.clients]
      return {
        ...state,
        clients: [...clients],
      }
    }
    case FILTER_PRODUCTS: {
      const products = [...action.payload.products]
      const productFilter = products.map((item) => (
        {
          label: item.productName, text: `${item.productName} (${item.productCode})`, value: item.productId, key: item.id, code: item.productCode,
        }));
      return {
        ...state,
        products: [...products],
        productFilter: [...productFilter],
      }
    }
    case LOADER: {
      return {
        ...state,
        loading: action.payload,
      }
    }
    case DASHBOARD_DATA: {
      const {
        approved, delayed, rejected, reported,
      } = action.payload
      return {
        ...state,
        dashboardReports: {
          approved, delayed, rejected, reported,
        },
      }
    }
    case REMOVE_ASSIGN_PRODUCT_FROM_COMMON: {
      const { payload, productId } = action
      const { products } = state
      const product = products.find((item) => item.id === productId)
      const ind = products.findIndex((item) => item.id === productId)
      const users = [...product.managerProduct]
      const newUsers = users.filter((item) => item.id !== payload)
      product.managerProduct = [...newUsers]
      const newProducts = [...products.slice(0, ind), { ...product }, ...products.slice(ind + 1)]
      return {
        ...state,
        products: [...newProducts],
      }
    }
    case UPDATE_PRODUCT_USERS: {
      const { products } = state
      const users = [...action.payload.users]
      const { productId } = action
      const product = products.find((item) => item.id === productId)
      const ind = products.findIndex((item) => item.id === productId)
      product.managerProduct = [...users]
      const newProducts = [...products.slice(0, ind), { ...product }, ...products.slice(ind + 1)]
      return {
        ...state,
        products: [...newProducts],
      }
    }
    case GET_STATES: {
      return {
        ...state,
        states: [...action.payload],
      }
    }
    case GET_CITIES: {
      return {
        ...state,
        cities: [...action.payload],
      }
    }
    case FILTER_SUPPLIERS: {
      const suppliers = [...action.payload.suppliers]
      return {
        ...state,
        suppliers: [...suppliers],
      }
    }
    case FILTER_RO:
    {
      const ro = [...action.payload.ro]
      return {
        ...state,
        ro: [...ro],
      }
    }
    case ERROR_DIALOG: {
      return {
        ...state,
        errorDialog: action.payload,
      }
    }
    case FILTER_CLIENTS_DASHBOARD: {
      const clients = [...action.payload]
      return {
        ...state,
        clientsDashboard: [...clients],

      }
    }
    case FILTER_PRODUCTS_CLIENTS_DASHBOARD: {
      const products = [...action.payload]
      return {
        ...state,
        productsOfClientDashboard: [...products],

      }
    }
    case FILTER_CAMPAIGNS_CLIENTS_DASHBOARD: {
      const campaigns = [...action.payload]
      return {
        ...state,
        campaignsOfClientDashboard: [...campaigns],
      }
    }
    case FILTER_ESTIMATES_CLIENTS_DASHBOARD: {
      const estimates = [...action.payload]
      return {
        ...state,
        estimatesOfClientDashboard: [...estimates],
      }
    }
    case FILTER_SITES_CLIENTS_DASHBOARD: {
      const { data } = action.payload
      const { cities, states, mediaTypes } = action.payload.filters
      return {
        ...state,
        sitesOfClientDashboard: [...data],
        clientCities: cities,
        clientStates: states,
        clientMediaTypes: mediaTypes,
      }
    }
    case FILTER_SITES_AUDITOR_DASHBOARD: {
      const { data } = action.payload
      const { cities, states, mediaTypes } = action.payload.filters
      return {
        ...state,
        sitesOfAuditorDashboard: [...data],
        clientCities: cities,
        clientStates: states,
        clientMediaTypes: mediaTypes,
      }
    }
    case FILTER_CLIENTS_CAMPAIGNS: {
      const campaigns = [...action.payload]
      return {
        ...state,
        clientsCampaigns: [...campaigns],

      }
    }

    case FILTER_CLIENTS_DASHBOARD_DATA: {
      return {
        ...state,
        clientDashboardData: action.payload,
      }
    }
    case UPDATE_AUDITOR_SITES: {
      const sites = state.sitesOfAuditorDashboard
      const index = sites.findIndex((item) => item.id === action.payload.id)
      const newSites = [...sites.slice(0, index), { ...action.payload }, ...sites.slice(index + 1)]
      return {
        ...state,
        sitesOfAuditorDashboard: newSites,
      }
    }
    default:
      return state;
  }
};

export default CommonReducer;
